export default "__VITE_ASSET__569b491b__"